<template>
  <div class="live-btn-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LButtonGroup',
}
</script>
